// extracted by mini-css-extract-plugin
export default {"Concerns":"Concerns_Concerns__jV0ma","cardGrid":"Concerns_cardGrid__XpI2L","topBar":"Concerns_topBar__m3VRQ"};